// /src/HeroSection.js

import React, { useEffect } from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection({ text1 = '', text2 = '', video, loop = true }) {
  
  useEffect(() => {
    const heroContainer = document.querySelector('.hero-container');
    if (heroContainer) {
      heroContainer.classList.add('animation-active');
    }
  }, []);
  
  return (
    <div className='hero-container'>
      <video 
        src={video} 
        autoPlay 
        loop={loop} 
        muted 
        playsInline // Prevents fullscreen on mobile devices
        className='background-video' // Added class for custom styling
      />
      <h1>{text1}</h1>
      <h2>{text2}</h2>
    </div>
  );
}

export default HeroSection;
